/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps, InspectorControls,InnerBlocks } from '@wordpress/block-editor';
import { Shape } from "./components/shape.js";
import {TopShapePanel  } from "./components/panelitem/topshapepanel.js";
import {BottomShapePanel  } from "./components/panelitem/bottomshapepanel.js";

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit(props) {
	const {attributes, setAttributes} = props;
	const {className, ...blockProps} = useBlockProps();
	return (
		<>
		
		<section className={`${className} alignfull fse-shape-section`} {...blockProps} >
			{ attributes.showTopShape && 
			<Shape
        	height ={attributes.topShapeHeight}
        	width ={attributes.topShapeWidth}
        	color ={attributes.topShapeColor}
        	flipX ={attributes.topFlipX}
        	flipY ={attributes.topFlipY} 
			/> 
			}
			<InnerBlocks />
			{ attributes.showBottomShape && 
			<Shape 
			isbottom = {true}
			height ={attributes.bottomShapeHeight}
			width ={attributes.bottomShapeWidth}
			color ={attributes.bottomShapeColor}
			flipX ={attributes.bottomFlipX}
			flipY ={attributes.bottomFlipY} 
			/> 
			}
		</section>
		<InspectorControls>
			<TopShapePanel
			attributes={attributes} 
        	setAttributes={setAttributes}
			/>
			<BottomShapePanel
			attributes={attributes} 
        	setAttributes={setAttributes}
			/>
		</InspectorControls>
		</>

		
	);
}
